export default "__VITE_ASSET__BtW8rpj9__"